import styled from 'styled-components';

type SettingsToggleProps = {
  selected: boolean;
};

const backgroundColor = ({ selected }: SettingsToggleProps): string => {
  return selected ? '#43aa8b' : '#e7e7e7';
};

const textColor = ({ selected }: SettingsToggleProps): string => {
  return selected ? '#ffffff' : '#666666';
};

const fontWeight = ({ selected }: SettingsToggleProps): string => {
  return selected ? '600' : '400';
};

/* A two-option segmented control: the picked side is filled, the other is quiet. */
export const SettingsToggle = styled.button<SettingsToggleProps>`
  border: none;
  cursor: pointer;
  padding: 8px 12px;
  margin: 0;
  background-color: ${backgroundColor};
  color: ${textColor};
  font-family: 'Nunito', sans-serif;
  font-weight: ${fontWeight};
  font-size: 14px;
  flex: 1;

  &:first-child {
    border-radius: 4px 0 0 4px;
  }

  &:last-child {
    border-radius: 0 4px 4px 0;
  }
`;
